import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholderV2: {
		id: 'servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-picker.placeholder-v-2',
		defaultMessage: 'Search user name, group or customer organization',
		description:
			'Placeholder text for the user picker in the request type permission configuration modal.',
	},
	add: {
		id: 'servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-picker.add',
		defaultMessage: 'Add',
		description:
			'Add button text for the request type permission configuration modal to add a principal.',
	},
	errorV2: {
		id: 'servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-picker.error-v-2',
		defaultMessage: 'Error loading users, groups and customer organizations',
		description:
			'Error message displayed in the picker when we failed to load the users, groups and customer organizations.',
	},
	ariaLabel: {
		id: 'servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-picker.aria-label',
		defaultMessage: 'User and group picker',
		description:
			'Aria label for the user and group picker in the request type permission configuration modal.',
	},
});
